<template>
  <div class="about" style="background: #f6f6f6">
    <div class="top" style="background: #ffffff">
      <div class="logo">
        <img src="/about/logo.png"/>
      </div>
      <div class="sidebar">
        <ul>
          <li ><a style="color: black" @click="changeHash('#footer')">联系</a></li>
<!--          <li>故事</li>-->
          <li ><a style="color: black" @click="changeHash('#event')"> 活动</a></li>
          <li><a style="color: black" @click="changeHash('#case')">方案</a></li>
          <li><a style="color: black" @click="changeHash('#course')">课程</a></li>
        </ul>
      </div>
    </div>
    <div class="body" style="width: 1200px; background: #ffffff;height: 3500px;
    margin-left: auto;margin-right: auto;margin-top: -5px">
      <div class="main">
        <div class="cover"><img src="/about/main.jpg" /></div>
        <div class="content">
          <div style="font-size: 10px">
            <div class="text">
              · 我们凝聚志同道合的伙伴，构建一个理念，共同形成一种人类发展的满意度。
            </div>
            <div class="text">
              · 我们联结卓越，传播关爱，激发人的善意，用积极的行动来丰富社区的生活。
            </div>
            <div class="text">
              · 我们期盼每个人都获得尊重，激发人的潜能，促进人的发展。
            </div>
            <div class="text">
              · 我们用行动传承博雅，倡导大家从自我管理做起，自我教练、自我实践、自我
              成长，影响身边的人，默默地把这个世界变得更好。
            </div>
          </div>
<!--          <img src="/about/content.jpg"/>-->
        </div>
      </div>
      <div class="process" id="process">
        <div class="left-title">
          <h2>我们的历程</h2>
        </div>
        <div class="process-content">
<!--         <img class="process-left" style="margin-top: 20px;width: 37%;left:6%"-->
<!--              src="/about/process-02.png"/>-->
<!--          <img class="process-bar" src="/about/process.jpg" />-->
<!--          <img class="process-right" style="margin-top: 165px;width: 20%;left: 64%;"-->
<!--               src="/about/process-03.png"/>-->
<!--          <img class="process-left" style="margin-top: 320px;width: 33%;left:10%"-->
<!--               src="/about/process-04.png"/>-->
          <img style="width: 50%;
          margin-left: 20%;margin-right: auto;margin-top: -15px" src="/about/process-01-pc.PNG"/>
        </div>
      </div>
      <div class="course" id="course">
        <div class="right-title">
          <h2>学习课程</h2>
        </div>
        <div class="course-content">
          <img  src="/about/course-01.png" />
          <img src="/about/course-02.png" />
          <img src="/about/course-03.png" />
          <img src="/about/course-04.png" />
        </div>
      </div>
      <div class="case" id="case">
        <div class="left-title">
          <h2>学习方案</h2>
        </div>
        <div class="case-content">
          <img style="margin-top: 30px" src="/about/case-01.png" />
          <img style="margin-top: 15px" src="/about/case-02.png" />
          <div class="case-content-text" >
            <div class="case-content-text-detail">
              <div>·系统学习经典理论</div>
              <div>·深度实践融合时代</div>
              <div>·培养持续学习习惯</div>
              <div>·成为自己私人教练</div>
            </div>
            <div class="case-content-text-detail">
              <div>·提供自我管理工具</div>
              <div>·经典而丰富的案例</div>
              <div>·共创你的专属课堂</div>
              <div>·构建自我管理体系</div>
            </div>
          </div>
        </div>
      </div>
      <div class="event" id="event">
        <div class="right-title">
          <h2>近期活动</h2>
        </div>
        <div class="event-content">
          <img src="/about/event-01.png" />
          <img src="/about/event-02.png" />
          <img src="/about/event-03.png" />
          <img src="/about/event-04.png" />
          <img src="/about/event-05.png" />
          <img src="/about/event-06.png" />
        </div>
      </div>
    </div>
    <div class="footer" id="footer">
      <div class="footer-img">
        <img src="/about/contact.jpg" />
      </div>
      <div class="footer-content">
        <div class="footer-content-text">
          <div class="footer-content-text-detail">上海市静安舒坦社区公益服务中心</div>
          <div class="footer-content-text-detail">地址：上海市延安中路841号东方海外大厦裙楼U Cube 206室</div>
          <div class="footer-content-text-detail">邮箱： service@52weeks.com.cn</div>
        </div>
      </div>
      <div class="footer-logo">
        <div class="footer-logo-img">
            <img src="/about/footer-logo.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';

export default {
  name: 'about',
  store,
  data() {
    return {
      msg: store.state.count,
    };
  },
  methods: {
    changeHash(idName) {
      console.log('点击了');
      document.querySelector(idName).scrollIntoView(true);
    },
  },
};
</script>
<style scoped>
  .logo img {
    float: left;
    width: 300px;
    margin-left: 5px;
    margin-top: -1px;
  }
  .main img {
    width: 100%;
    margin-top: 5px;
  }
  .top{
    height: 50px;
    margin-top: -10px;
  }
  .sidebar ul li {
    display: inline;
    float: right;
    margin-right: 50px;
    font-size: 30px;
  }
  .content {
    margin-top: 70px;
    width: 80%;
    margin-left: 10%;
  }
  .text {
    margin-right: 10px;
    margin-left: 10px;
    font-size: 20px;
    font-weight: 600;
    font-family: Microsoft YaHei;
    letter-spacing:0px
  }
  .left-title {
    font-size: 20px;
    height: 45px;
    width: 80%;
    border-bottom: 3px solid #cc6666;
  }
  .process{
    margin-top: 90px;
  }
  .left-title h2{
    float: right;
    font-weight: 600;
  }
  .right-title h2{
    font-weight: 600;
  }
  .process-bar {
    width: 30%;
    float: left;
    /*margin-top: -12px;*/
    left: 37%;
    z-index:-1;
    position: absolute;
  }
  .process-content{
    /*width: 90%;*/
    margin-left: auto;
    margin-right: auto;
  }
  .process-content img {
    position: relative;
    top:0px;
  }
  .process-left {
    position: absolute;
    float: left;
    z-index: 20;
  }
  .process-right {
    position: absolute;
    float: left;
    width: 20%;
    z-index: 20;
  }
  .course {
    margin-top: 120px;
  }
  .case {
    margin-top: 200px;
  }
  .event {
    top: 120px;
    position: relative;
  }
  .right-title {
    font-size: 20px;
    float: right;
    height: 45px;
    width: 80%;
    border-bottom: 3px solid #cc6666;
  }
  .course-content {
    position: relative;
    top: 70px;
  }
  .course-content img {
    width: 20%;
    margin-left: 4%;
  }
  .case-content{
    position: relative;
    top:50px;
  }
  .case-content img {
    float: left;
    width: 25%;
    margin-left: 17%;
  }
  .case-content-text {
    width: 100%;
    float: left;
    margin-left: 15%;
  }
  .case-content-text-detail {
    width:35%;
    float: left;
    font-weight: 800;
    font-size: 19px;
    margin-left: 7%;
  }
  .case-content-text-detail div {
    margin-bottom: 5px;
  }
  .event-content{
    position: relative;
    top: 80px;
  }
  .event-content img{
    width: 25%;
    margin-left: 7%;
  }
  .footer{
    width: 1200px;
    position: relative;
    /*top:250px;*/
    margin-left: auto;
    margin-right: auto;
    background: #ffffff;
    margin-top: -100px;
  }
  .footer-img img {
    width: 100%;
  }
  .footer-content{
    position: relative;
    top: 40px;
  }
  .footer-content-text-detail {
    font-size: 20px;
    margin-left: 30%;
    width: 60%;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .footer-logo {
    position: relative;
    top: 60px
  }
  .footer-logo-img img {
    margin-left: 37%;
    width: 25%;
    /*margin-bottom: 60px;*/
  }
</style>
